export default [
    {
        path: '/sistema-documentos/procesos/manual-funciones',
        name: 'manual-funciones',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/ManualFunciones.vue'),
        meta: {
			title: 'i18n:sistema_documento.transacciones.manual_funcion.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-funciones',
            pageTitle: 'sistema_documento.transacciones.manual_funcion.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Transacciones",
                    active: true
                },
                {
                    text: "sistema_documento.transacciones.proceso",
                    active: true
                }
            ]
        },
    },
    {
        path: '/configuracion-permisos',
        name: 'configuracion-permisos-sistemaDocumentos',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/Permisos.vue'),
        meta: {
			title: 'i18n:sistema_documento.configuracion.permiso_departamento.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-configuracion',
            pageTitle: 'sistema_documento.configuracion.permiso_departamento.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true,
                },
                {
                    text: "Configuracion",
                    active: true,
                },
            ]
        },
    },
    {
        path: '/sistema-documentos/procesos/manual-procedimientos',
        name: 'manual-procedimientos',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/ManualProcedimientos.vue'),
        meta: {
			title: 'i18n:sistema_documento.transacciones.manual_procedimiento.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-procedimientos',
            pageTitle: 'sistema_documento.transacciones.manual_procedimiento.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Transacciones",
                    active: true
                },
                {
                    text: "sistema_documento.transacciones.proceso",
                    active: true
                }
            ]
        },
    },
    {
        path: '/sistema-documentos/procesos/instructivos',
        name: 'instructivos',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/Instructivos.vue'),
        meta: {
			title: 'i18n:sistema_documento.transacciones.instructivo.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-instructivos',
            pageTitle: 'sistema_documento.transacciones.instructivo.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Transacciones",
                    active: true
                },
                {
                    text: "sistema_documento.transacciones.proceso",
                    active: true
                }
            ]
        },
    },
    {
        path: '/sistema-docuemtos/mantenimiento-procesos',
        name: 'mantenimiento-procesos',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/MantenimientoRevisiones.vue'),
        meta: {
			title: 'i18n:sistema_documento.mantenimiento.revision.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-mantenimiento-revisiones',
            pageTitle: 'sistema_documento.mantenimiento.revision.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Mantenimiento",
                    active: true
                },
            ]
        },
    },
    {
        path: '/sistema-documentos/organigrama-institucional',
        name: 'organigrama-institucional',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/OrganigramaInstitucional.vue'),
        meta: {
			title: 'i18n:sistema_documento.transacciones.org_institucional.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-organigrama-institucional',
            pageTitle: 'sistema_documento.transacciones.org_institucional.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Transacciones",
                    active: true
                },
            ]
        },
    },
    {
        path: '/sistema-documentos/organigrama-departamental',
        name: 'organigrama-departamental',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/OrganigramaDepartamental.vue'),
        meta: {
			title: 'i18n:sistema_documento.transacciones.org_jerarquia.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-organigrama-departamental',
            pageTitle: 'sistema_documento.transacciones.org_jerarquia.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Transacciones",
                    active: true
                },
            ]
        },
    },
    {
        path: '/sistema-documentos/mision-vision',
        name: 'mision-vision',
        component: () =>
            import ('@/views/pages/sistemaDocumentos/MisionVision.vue'),
        meta: {
			title: 'i18n:sistema_documento.informes.vision_mision.titulo',
            resource: 'Sistema Documentos',
            action: 'ver-sistema-documentos-mision-vision',
            pageTitle: 'sistema_documento.informes.vision_mision.titulo',
            breadcrumb: [
                {
                    text: "sistema_documento.titulo",
                    active: true
                },
                {
                    text: "Informes",
                    active: true
                },
            ]
        },
    }
]
